import React, {Component} from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { clearUserProfile } from '../../../../redux/actions/user';
import { clearBugsnagUser } from '../../../../redux/actions/bugsnag';
import Alerts from '../../../../prototypes/Alerts';
import EtelAPI from '../../../../api/EtelAPI';
import PageSizeSelector from '../../../../presentation/PageSizeSelector';
import PagePositionLabel from '../../../../presentation/PagePositionLabel';
import Pagination from '../../../../presentation/Pagination';
import NoSearchResults from '../../../../presentation/NoSearchResults';
import Loading from '../../../../presentation/Loading';

import ReactGrid, 
{ 
  ReactGridHeader,
  ReactGridColumn,
  ReactGridBody,
  ReactGridRowTemplate,
  ReactGridNoRowsTemplate,
  ReactGridReadOnlyCell
} from '../../../../presentation/ReactGrid';

class LeadGenChangeHistory extends Component {
  constructor( props ) {
    super( props );
    this.title = 'Change History';
    /* List of indicies that represent the data being fetched */
    this.FETCH_INDICES = {
      ALL: 0,
      CHANGE_LOGS: 1
    };

    this.state = {
      TABLE_NAME: 'Leadgen_def',
      OPERATION: '',
      DNIS: '',
      CHANGE: '',
      changeTypeOptions: [
        { value: 'Leadgen_def', text: 'Leadgen Definition' },
        { value: 'Leadgen_numbers', text: 'Leadgen Numbers' },
        { value: 'Leadgen_off_net', text: 'Leadgen Off Net' },
        { value: 'Leadgen_on_net', text: 'Leadgen On Net' }
      ],
      operationOptions: [],
      row: props.row === undefined ? {} : props.row,
      tableName: 'Leadgen_def',
      dataSource: [],
      pageSize: 25,
      pageIndex: 0,
      loading: false, 
    };

    // Component Events
    this.fetchData = this.fetchData.bind( this );
    this.onChangeTypeChange = this.onChangeTypeChange.bind( this );
    this.onOperationChange = this.onOperationChange.bind( this );
    this.onDNISChange = this.onDNISChange.bind( this );
    this.onDNISKeyDown = this.onDNISKeyDown.bind( this );
    this.onChangeChange = this.onChangeChange.bind( this );
    this.onChangeKeyDown = this.onChangeKeyDown.bind( this );
    
    this.onResetClick = this.onResetClick.bind( this );
    this.onDeleteAllClick = this.onDeleteAllClick.bind( this );
    this.onPageSizeChanged = this.onPageSizeChanged.bind( this );
    this.onPageChanged = this.onPageChanged.bind( this );
  }

  componentDidMount( ) {
    this.fetchData();
  }

  componentDidUnmont() {
    this.stopWatchNumbers();
  }

  doLogOff( ) {
    const { dispatch } = this.props;
    const auth = this.props.auth;
    const history = this.props.history;
    auth.logout();
    dispatch( clearBugsnagUser() );
    dispatch( clearUserProfile() );
    history.push( '/login' );
  }

  onHandleException( e ) {
    const bugsnag = this.props.bugsnag;
    const { dispatch } = this.props;
    const alerts = new Alerts( bugsnag, dispatch );
    const status = e.status === undefined ? 0 : e.status;
    if( status === 410 ) {
      alerts.INFO( this.title, 'Your session has expired.' , 5000 );
      this.doLogOff();
    } else if( status === 500 ) {
      alerts.INFO( this.title, e.statusText , 5000 );
    } else {
      if( e.statusText !== undefined ) {
        alerts.CRITICAL( this.title, e, false );
      } else {
        alerts.CRITICAL( this.title, e );
      }
    }
  }

  onChangeTypeChange( e ) {
    this.setState( { 
      loading: true,
      dataSource: [],
      TABLE_NAME: e.target.value  
    }, () => {
      this.fetchData( this.FETCH_INDICES.CHANGE_LOGS );
    } );
  }

  onOperationChange( e ) {
    this.setState( { 
      loading: true,
      OPERATION: e.target.value
    }, () => {
      this.fetchData( this.FETCH_INDICES.CHANGE_LOGS );
    } );
  }

  onDNISChange( e ) {
    if( e.target.value === '' ) {
      this.setState( { 
        loading: true,
        DNIS: e.target.value
      }, () => { 
        this.fetchData( this.FETCH_INDICES.CHANGE_LOGS );
      } );
    } else {
      this.setState( { 
        DNIS: e.target.value
      } );
    }
  }

  onDNISKeyDown( e ) {
    if( e.key === 'Enter' ) {
      this.setState( { 
        loading: true,
        pageIndex: 0,
      }, () => { 
        this.fetchData( this.FETCH_INDICES.CHANGE_LOGS );
      } );
    } 
  }

  onChangeChange( e ) {
    if( this.e.target.value === '' ) {
      this.setState( { 
        loading: true,
        CHANGE: e.target.value
      }, () => {
        this.fetchData( this.FETCH_INDICES.CHANGE_LOGS );
      } );
    } else {
      this.setState( { 
        CHANGE: e.target.value
      } );
    }
  }

  onChangeKeyDown( e ) {
    if( e.key === 'Enter' ) {
      this.setState( { 
        loading: true,
        pageIndex: 0,
      }, () => { 
        this.fetchData( this.FETCH_INDICES.CHANGE_LOGS );
      } );
    } 
  }

  onResetClick( e ) {
    this.setState( {
      number:'',
    }, () => { 
      this.getData();
    } );
  }

  onDeleteAllClick( e ) {
    this.deleteAllMatchNumbers();
  }

  onPageSizeChanged( pageSize ) {
    this.setState( { 
      pageSize: pageSize
    } );
  }

  onPageChanged( page, e ) {
    this.setState( { 
      pageIndex: page.index
    } );
  }

  fetchChangeLogs() {
    const row = this.state.row;
    let api = new EtelAPI( 'leadgen/changelogs' );
    const parameters = [
      { TABLE_NAME: this.state.TABLE_NAME },
      { OPERATION: this.state.OPERATION },
      { DNIS: row.DEFDNIS },
      { CHANGE: this.state.CHANGE }
    ];
    return new Promise( ( resolve, reject ) => {
      api.get( parameters ).then( ( result ) => { 
        resolve( result );
      } ).catch( ( exception ) => {  
        reject( exception );
      } );
    } );
  }

  fetchChangeHistoryList( columnName ) {
    let api = new EtelAPI( 'leadgen/changehistorylist' );
    const parameters = [
      { COLUMN_NAME: columnName }
    ];
    return new Promise( ( resolve, reject ) => { 
      api.get( parameters ).then ( ( result ) => { 
        resolve( result );
      } ).catch( ( exception ) => { 
        reject( exception );
      } );
    } );
  }

  fetchData( fetchIndex ) { 

    if( fetchIndex === undefined ) {
      fetchIndex = this.FETCH_INDICES.ALL;
    }

    let fetchChangeLogs = () => { 
      return this.fetchChangeLogs();
    };

    let fetchChangeHistoryList = ( columnName ) => { 
      return this.fetchChangeHistoryList( columnName );
    };

    let callbacks = [];
    if( fetchIndex === this.FETCH_INDICES.ALL ) {
      callbacks = [
        fetchChangeLogs(),
        fetchChangeHistoryList( 'Leadgen,General' ),
        fetchChangeHistoryList( 'OPERATION' )
      ];
    } else if( fetchIndex === this.FETCH_INDICES.CHANGE_LOGS ) {
      callbacks = [
        fetchChangeLogs()
      ];
    } else {
      callbacks = [
        fetchChangeLogs(),
        fetchChangeHistoryList( 'Leadgen,General' ),
        fetchChangeHistoryList( 'OPERATION' )
      ];
    }
    
    // Change History Enumeration
    const PROMISE_INDICES = {
      CHANGE_LOGS: 0,
      CHANGE_TYPES: 1,
      OPERATIONS: 2
    };

    // Match if callback are set correctly
    if( callbacks !== undefined ) {
      // Check to see if any callbacks were added to array
      if( callbacks.length > 0 ) {
        // Execute all promises and return all data.
        Promise.all( callbacks ).then( ( results ) => {
          // Get the change
          const changeLogs = results[ PROMISE_INDICES.CHANGE_LOGS ];
          if( changeLogs !== undefined ) {
            if( changeLogs.length > 0 ) {
              for( var rowIndex = 0; rowIndex < changeLogs.length; rowIndex++ ) {
                changeLogs[ rowIndex ].CHANGE = this.formatChange( changeLogs[ rowIndex ].CHANGE );
              }
            }
          }
          
          let changeTypes = results[ PROMISE_INDICES.CHANGE_TYPES ];
          if( changeTypes === undefined ) {
            changeTypes = this.state.changeTypes === undefined ? [] : this.state.changeTypes;
          }

          let operations = results[ PROMISE_INDICES.OPERATIONS ];
          if( operations === undefined ) {
            operations = this.state.operations === undefined ? [] : this.state.operations;
          }

          this.setState( {
            loading: false, 
            dataSource: changeLogs,
            changeTypes: changeTypes,
            operations: operations
          } );
        } ).catch( ( exception ) => { 
          this.onHandleException( exception );
        } ) ;
      }
    }

  }
  
  formatChange( value ) {
    let newValue = '';
    if( value !== undefined ) {
      let nvp = value.split( '&' );
      if( nvp !== undefined ) {
        if( nvp.length > 0 ) {
          for( var index = 0; index < nvp.length; index++ ) {
            nvp[ index ] = nvp[ index ].replace( '=',': ' ).trim();
          }
          newValue = nvp.join( '\n' ).trim();
        }
      }
    }
    return newValue;
  }


  getPageSizeOptions() { 
    let options = [];
    const dataSource = this.state.dataSource;

    if( dataSource === undefined ) {
      return options;
    }

    if( dataSource === null ) {
      return options;
    }
    
    if( dataSource.length >= 25 ) {
      options.push( { value: 25, selected: true } );
    }

    if( dataSource.length >= 50 ) {
      options.push( { value: 50, selected: false } );
    }

    if( dataSource.length >= 75 ) {
      options.push( { value: 75, selected: false } );
    }

    if( dataSource.length >= 100 ) {
      options.push( { value: 100, selected: false } );
    }

    if( dataSource.length >= 500 ) {
      options.push( { value: 500, selected: false } );
    }

    if( dataSource.length >= 1000 ) {
      options.push( { value: 1000, selected: false } );
    }

    return options;
  }

  getDialogContentStyle() {
    let styles = {};
    styles.display = 'grid';
    styles.gridTemplateRows = '50px 570px 50px'; 
    styles.width = '100%';
    styles.height = '670px';
    return styles;
  }

  getDialogContentHeaderStyle() {
    let styles = {};
    styles.display = 'grid';
    styles.gridTemplateColumn = 'auto auto auto auto';
    styles.gridRow = '1 / 2';
    styles.gridColumn = '1 / 2';
    styles.alignItems = 'center';
    styles.justifyContent = 'space-around';
    return styles;
  }

  getDialogContentHeaderCell1Style() { 
    let styles = {};
    styles.userSelect = 'none';
    styles.gridColumn = '1 / 2';
    return styles;
  }

  getDialogContentHeaderCell2Style() { 
    let styles = {};
    styles.userSelect = 'none';
    styles.gridColumn = '2 / 3';
    return styles;
  }

  getDialogContentHeaderCell3Style() { 
    let styles = {};
    styles.userSelect = 'none';
    styles.gridColumn = '3 / 4';
    return styles;
  }

  getDialogContentHeaderCell4Style() { 
    let styles = {};
    styles.userSelect = 'none';
    styles.gridColumn = '4 / 5';
    return styles;
  }

  getDialogContentHeaderCell5Style() { 
    let styles = {};
    styles.userSelect = 'none';
    styles.gridColumn = '5 / 6';
    return styles;
  }

  getDialogContentBodyStyle() { 
    let styles = {};
    styles.gridRow = '2 / 3';
    styles.gridColumn = '1 / 2';
    return styles;    
  }

  getDialogContentFooterStyle() { 
    let styles = {};
    styles.display = 'grid';
    styles.gridRow = '3 / 4';
    styles.gridColumn = '1 / 2';
    styles.borderTop = 'solid thin #C1C1C1';
    return styles;    
  }

  getDialogContentFooterCell1Style() {
    let styles = {};
    styles.display = 'flex';
    styles.flexFlow = 'row wrap';
    styles.gridRow = '1 / 2';
    styles.gridColumn = '1 / 2';
    styles.alignItems = 'center';
    styles.justifyContent = 'flex-start';
    styles.width = '100%';
    styles.height = '100%';
    styles.paddingLeft = '5px';
    return styles;
  }

  getDialogContentFooterCell2Style() {
    let styles = {};
    styles.display = 'flex';
    styles.flexFlow = 'row wrap';
    styles.gridRow = '1 / 2';
    styles.gridColumn = '2 / 3';
    styles.alignItems = 'center';
    styles.justifyContent = 'center';
    styles.width = '100%';
    styles.height = '100%';    
    return styles;
  }

  getDialogContentFooterCell3Style() {
    let styles = {};
    styles.paddingTop='5px';
    styles.display = 'flex';
    styles.flexFlow = 'row wrap';
    styles.gridRow = '1 / 2';
    styles.gridColumn = '3 / 4';
    styles.alignItems = 'center';
    styles.justifyContent = 'flex-end';
    styles.width = '100%';
    styles.height = '100%';    
    return styles;
  }
  
  getLabelStyle( ) {
    let styles = {};
    styles.marginLeft = '5px';
    styles.color = '#C1C1C1';
    styles.height = '100%';
    return styles;
  }

  getInputStyle() { 
    let styles = {};
    styles.outline='none';
    styles.height = '32px';
    styles.border = 'solid thin #c1c1c1';
    styles.marginLeft = '10px';
    styles.width = '150px';
    return styles;
  }

  getDropDownStyle() {
    let styles = {};
    styles.outline = 'none';
    styles.height = '32px';
    styles.border = 'solid thing #c1c1c1';
    styles.marginLeft = '10px';
    styles.width = '150px';
    return styles;
  }

  getSearchResetButtonStyle() { 
    let styles = {};
    styles.width = '200px';
    return styles;
  }

  getNumbersStatusLabelStyle() { 
    let styles = {};
    styles.width = 'auto';
    styles.height = '32px';
    styles.color = '#C1C1C1';
    if( this.state.numbersMatch === this.MATCH_CHECKING_DISTRIBUTION ) {
      styles.color='#C1C1C1';
      styles.fontWeight='normal';
    } 
    
    if( this.state.numbersMatch === this.MATCH_VALID ) {
      styles.color='green';
      styles.fontWeight='normal';
    } 
    
    if( this.state.numbersMatch === this.MATCH_INVALID ) {
      styles.color='red';
      styles.fontWeight='bold';
    }

    return styles;
  }

  onRenderChangeTypeOptions() {
    let options = [];
    const changeTypes = this.state.changeTypes;
    if( changeTypes !== undefined ) {
      if( changeTypes.length > 0 ) {
        for( var index = 0; index < changeTypes.length; index++ ) {
          const row = changeTypes[ index ];
          if( row.TABLE_NAME.trim() !== '' ) {
            options.push(
              <option key={'leadgen-change-types-options-' + index.toString()} value={row.TABLE_NAME}>{row.DESCRIPTION}</option> 
            );
          }
        }
      }
    }
    return options;
  }

  onRenderOperationOptions() {
    let options = [];
    const operations = this.state.operations;
    if( operations !== undefined ) {
      if( operations.length > 0 ) {
        for( var index = 0; index < operations.length; index++ ) {
          const row = operations[ index ];
          options.push(
            <option key={'leadgen-operations-options-' + index.toString()} value={row.OP}>{row.OPERATION}</option> 
          );
        }
      }
    }
    return options;
  }

  onRenderDialogContentBody() {
    if( this.state.loading === false ) {
      return (
        <ReactGrid 
          tagName="grid" 
          dataSource={this.state.dataSource}
          paging={true}
          pageSize={this.state.pageSize}
          pageIndex={this.state.pageIndex}
          height="60vh"
          width="78.5vw"
          loading={this.state.loading}
        >
          <ReactGridHeader tagName="header">
            {/* <ReactGridColumn
            index={0}
            tagName='column' 
            caption='Database'
            width='100px'
            sorted='DB_NAME'
            dataType='string'
          />          
          <ReactGridColumn
            index={1}
            tagName='column' 
            caption='Table'
            width='150px'
            sorted='TABLE_NAME'
            dataType='string'
          /> */}
            <ReactGridColumn
              index={0}
              tagName='column' 
              caption='Key Name'
              sorted="KEY_NAME"
              width='200px'
              dataType='string'
            />
            <ReactGridColumn
              index={1}
              tagName='column' 
              caption='Key Value'
              sorted="KEY_VALUE"
              width='100px'
              dataType='string'
            />                                  
            <ReactGridColumn
              index={2}
              tagName='column' 
              caption='DNIS'
              sorted="DNIS"
              width='100px'
              dataType='string'
            />                                  
            <ReactGridColumn
              index={3}
              tagName='column' 
              caption='Operation'
              sorted="OPERATION"
              width='300px'
              dataType='string'
            />        
            <ReactGridColumn
              index={4}
              tagName='column' 
              caption='Change'
              sorted="CHANGE"
              width='300px'
              dataType='string'
            />                                  
            <ReactGridColumn
              index={5}
              tagName='column' 
              caption='Modified'
              sorted="ModifiedOnDate"
              width='200px'
              dataType='date'
              format="YYYY-MM-DD"
            />                                  
            <ReactGridColumn
              index={6}
              tagName='column' 
              caption='User'
              sorted="ModifiedByUser"
              width='100px'
            />                                  
            <ReactGridColumn
              index={7}
              tagName='column' 
              caption='Processed'
              sorted="PROCESSED_NAME"
              width='100px'
            />                                  
          </ReactGridHeader>
          <ReactGridBody tagName="body">
            <ReactGridRowTemplate tagName='rowTemplate'>
              {/* <ReactGridReadOnlyCell 
              tagName='readOnlyCell'
              column='DB_NAME'
              width='100px'
              align='left'
            />
            <ReactGridReadOnlyCell 
              tagName='readOnlyCell'
              column='TABLE_NAME'
              width='150px'
              align='center'
            /> */}
              <ReactGridReadOnlyCell 
                tagName='readOnlyCell'
                column="KEY_NAME"
                width='200px'
                align='center'
              />
              <ReactGridReadOnlyCell 
                tagName='readOnlyCell'
                column="KEY_VALUE"
                width='100px'
                align='center'
              />        
              <ReactGridReadOnlyCell 
                tagName='readOnlyCell'
                column="DNIS"
                width='100px'
                align='center'
              />                                
              <ReactGridReadOnlyCell 
                tagName='readOnlyCell'
                column="OPERATION"
                width='300px'
                align='center'
              />                                
              <ReactGridReadOnlyCell 
                tagName='readOnlyCell'
                column="CHANGE"
                width='300px'
                align='center'
              />                                 
              <ReactGridReadOnlyCell 
                tagName='readOnlyCell'
                column='ModifiedOnDate'
                width='200px'
                align='center'
                format="datetime"
              />
              <ReactGridReadOnlyCell 
                tagName='readOnlyCell'
                column='ModifiedByUser'
                width='100px'
                align='center'
              />
              <ReactGridReadOnlyCell 
                tagName='readOnlyCell'
                column='PROCESSED_NAME'
                width='100px'
                align='center'
              />
            </ReactGridRowTemplate>  
            <ReactGridNoRowsTemplate tagName='noRowTemplate' height='50px'>
              <NoSearchResults caption='There are no change history records' />
            </ReactGridNoRowsTemplate>          
          </ReactGridBody>
        </ReactGrid>  
      );
    } else {
      return (
        <Loading caption="Loading please wait..." width="250px" />
      );
    }
  }
  render( ) {
    let pageSize = this.state.pageSize;
    const pageStart = ( parseInt( this.state.pageIndex, 10 ) * parseInt( pageSize, 10 ) ) + 1;
    const pageEnd = pageStart + parseInt( pageSize, 10 ) - 1;
    const pageTotal = this.state.dataSource === undefined ? 0 : this.state.dataSource.length;
    let pageSizeSelectorControl = '';
    
    if( this.state.dataSource !== undefined ) {
      if( this.state.dataSource.length > 0 ) {
        if( this.state.dataSource.length >= this.state.pageSize ) {
          pageSizeSelectorControl = (
            <PageSizeSelector options={this.getPageSizeOptions()} onPageSizeChanged={this.onPageSizeChanged} /> 
          );
        }
      }
    }

    return (
      <span style={this.getDialogContentStyle()}>
        <span style={this.getDialogContentHeaderStyle()}>
          <span style={this.getDialogContentHeaderCell1Style()}>
            <span style={this.getLabelStyle()}>
              Change Type
            </span>
            <select style={this.getDropDownStyle()} value={this.state.TABLE_NAME} onChange={this.onChangeTypeChange}>
              {this.onRenderChangeTypeOptions()}
            </select>
            <span style={this.getLabelStyle()}>
              Options
            </span>
            <select style={this.getDropDownStyle()} value={this.state.OPERATION} onChange={this.onOperationChange}>
              {this.onRenderOperationOptions()}
            </select>
            <span style={this.getLabelStyle()}>
              Change (Use %)
            </span>
            <input 
              type="text" 
              value={this.state.CHANGE} 
              style={this.getInputStyle()} 
              onChange={this.onChangeChange} 
              onKeyDown={this.onChangeKeyDown} />
          </span>
          <span style={this.getDialogContentHeaderCell5Style()}>
            {pageSizeSelectorControl}
          </span>
        </span>
        <span style={this.getDialogContentBodyStyle()}>
          {this.onRenderDialogContentBody()}
        </span>
        <span style={this.getDialogContentFooterStyle()}>
          <span style={this.getDialogContentFooterCell1Style()}>
            <PagePositionLabel pagesize={pageSize} pagestart={pageStart} pageend={pageEnd} pagetotal={pageTotal} />
          </span>
          <span style={this.getDialogContentFooterCell2Style()}>
          </span>
          <span style={this.getDialogContentFooterCell3Style()}>
            <Pagination pageindex={this.state.pageIndex} totalitems={pageTotal} maxitemsperpage={this.state.pageSize} maxpages={6} onPageChanged={this.onPageChanged} />
          </span>
        </span>
      </span>
    );
  }
}

export default withRouter(
  connect(
    ( store ) => {
      return {
        auth: store.auth.auth,
        bugsnag: store.bugsnag.Bugsnag,
        user: store.user.user
      };
    }
  )( LeadGenChangeHistory ) );


// WEBPACK FOOTER //
// ./src/content/enterprise/leadgen/components/LeadGenChangeHistory.js